<template>
  <v-container class="pt-6 pb-0">
    <v-row class="info lighten-5 mb-4">
      <v-col>
        <v-icon class="mr-2" color="info lighten-1">info</v-icon>
        <span class="info--text caption" v-html="t.mdd.msgProxDias"></span>
      </v-col>
    </v-row>
    <!-- Recordatorios -->
    <v-row align="center">
      <v-col class="flex-grow-0 flex-shrink-1">
        <div class="caption">{{ t.mdd.recordatorios }}</div>
      </v-col>
      <v-col class="flex-grow-1 flex-shrink-0">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <template v-for="rec in oracionNoche.rec">
      <v-row :key="rec.dia" align="center">
        <v-col cols="6">{{ t.dias[rec.dia] }}</v-col>
        <v-col cols="4" class="text-right">
          <v-btn :disabled="!rec.act" @click="editar(rec.dia)" rounded small>
            {{ rec.hora }}
          </v-btn>
        </v-col>
        <v-col cols="2">
          <v-btn icon color="primary" @click.stop="rec.act = !rec.act">
            <v-icon
              v-text="rec.act ? 'notifications_active' : 'notifications_none'"
            ></v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <!-- Mostrar compromiso -->
    <v-divider class="my-4"></v-divider>
    <v-row class="px-0">
      <v-switch
        :label="t.mdd.msgMostCompr"
        v-model="oracionNoche.com"
      ></v-switch>
    </v-row>

    <v-dialog v-model="showTime" width="275px">
      <v-time-picker ampm-in-title full-width v-model="alm" :format="format">
        <v-row class="center px-4">
          <v-btn @click="showTime = false" text>
            CANCEL
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!alm" text color="primary" @click="saveTime()">
            Activar
            <v-icon right>notifications_active</v-icon>
          </v-btn>
        </v-row>
      </v-time-picker>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "user-oracion-noche",
  props: ["oracionNoche", "mdd"],
  data() {
    return {
      showTime: false,
      editando: 0,
      alm: ""
    };
  },
  computed: {
    format() {
      let bvs = this.params.bookVersions || [];
      let i = bvs.findIndex(bookV => {
        return bookV.cod === this.mdd.cod;
      });
      return i ? bvs[i].timeFormat : "ampm";
    },
    params() {
      return this.$store.getters["app/params"];
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  },
  methods: {
    editar(dia) {
      this.showTime = true;
      this.editando = dia;
    },
    saveTime() {
      // el array original domingo = 0, aquí domingo = 6
      let dia = this.editando === 0 ? 6 : this.editando - 1;
      this.oracionNoche.rec[dia].act = true;
      this.oracionNoche.rec[dia].hora = this.alm;
      this.showTime = false;
    }
  }
};
</script>
